export default "__VITE_ASSET__7V6EeZ37__"